<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <el-scrollbar class="scroll-bar-view">
          <el-tree
            :data="frame"
            :props="treeProps"
            class="shebeiDiv"
            @node-click="currentChange"
            :expand-on-click-node="true"
            :default-expand-all="false"
            :default-expanded-keys="['1']"
            :highlight-current="true"
            node-key="thirdDeviceId"
            ref="vuetree"
          >
            <template slot-scope="{ node }">
              <element-tree-line
                :node="node"
                :showLabelLine="true"
                :indent="16"
                class="tree-line"
              >
                <span class="custom-tree-node" style="display: block">
                  <span style="margin-left: 3px">{{ node.label }}</span>
                </span>
              </element-tree-line>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 主机设备列表 -->
        <div v-if="devShow" class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar flex-row">
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="iconfont icon-iconfontfanhui"
              @click="retBtn"
              >返回</el-button
            >
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-plus"
              v-auth="'/deviceaccess/index:addDevice'"
              @click="add"
              >新增</el-button
            >
            <!-- <el-button
              type="primary"
              class="iss-operation-button ml10"
              icon="iconfont icon-daoru"
              v-auth="'/deviceaccess/index:exportDevice'"
              @click="exportData"
              >导出</el-button
            > -->
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-delete"
              v-auth="'/deviceaccess/index:deleteDevice'"
              @click="delDev"
              >批量删除</el-button
            >
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table
              ref="devTab"
              :data="deviceData"
              :option="deviceOption"
              :page="devicePage"
              @row-save="handleCreate"
              @row-update="handleUpdate"
              @search-change="handleSearchChange"
              @search-reset="resetForm"
              @current-change="selectPage"
              @selection-change="selectionChange"
              @size-change="changeSize"
              @deviceMark-change="isShowControlCodeColumn"
              @controlMode-change="isShowControlCodeColumn"
            >
              <!-- 表单自定义 -->
              <template #controlCodeListForm="slotData">
                <el-select
                  v-model="slotData.row.controlCodeList"
                  multiple
                  @change="onControlChooseCode"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in pageState == 'edit'
                      ? controlCodeOption
                      : controlCodeData"
                    :key="item.controlCodeTypeCode || item.value"
                    :label="item.controlCodeTypeName || item.label"
                    :value="Number(item.controlCodeTypeCode || item.value)"
                  >
                    <span>{{ item.controlCodeTypeName || item.label }} </span>
                    <div class="rightBtn">
                      <span
                        @click.stop="onEditControlCodeType(item)"
                        title="点击编辑"
                        style="margin-right: 5px"
                        >编辑</span
                      >
                    </div>
                  </el-option>
                </el-select>
              </template>
              <!-- 定制操作栏按钮 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    class="iconfont icon-Detail"
                    @click="showDetail(scope.row)"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="设置密码"
                  placement="top"
                  v-auth="'/deviceaccess/index:updateDevice'"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    class="iconfont icon-mimashezhi"
                    @click="setPassword(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    v-auth="'/deviceaccess/index:updateDevice'"
                    @click="update(scope.row)"
                    icon="iconfont icon-xiugai"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="部件管理"
                  v-auth="'/deviceaccess/index:query'"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    @click="seeCamera(scope.row)"
                    v-if="scope.row.deviceMark == '27'"
                    icon="el-icon-s-tools"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
        <!-- 部件列表 -->
        <div v-else class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar" style="display: flex;">
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="iconfont icon-iconfontfanhui"
              @click="backNvr"
              >{{ $t("deviceAccess.button.back") }}</el-button
            >
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-plus"
              v-auth="'/deviceaccess/index:addDevice'"
              @click="add"
              >新增</el-button
            >
            <el-upload ref="upload"
                       class="upload-demo"
                       multiple
                       :limit="1"
                       :auto-upload="false"
                       :on-change="batchImport"
                       action
                       :show-file-list="false">
              <el-button type="primary"
                         v-auth="'/deviceaccess/index:addDevice'"
                         class="iss-operation-button"
                         icon="iconfont icon-daoru">导入</el-button>
            </el-upload>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-download"
                       @click="downTemplate">模板下载</el-button>
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table
              ref="partTab"
              :data="cameraData"
              :option="cameraOption"
              :page="cameraPage"
              @row-save="handlePartCreate"
              @row-update="handlePartUpdate"
              @search-change="handleSearchChange"
              @search-reset="resetForm"
              @current-change="selectPage"
              @selection-change="selectionChange"
              @size-change="changeSize"
            >
              <!-- 定制操作栏按钮 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    class="iconfont icon-Detail"
                    @click="showDetail(scope.row)"
                  ></el-button>
                </el-tooltip>
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="查看"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             @click="seeStatus(scope.row)"
                             icon="iconfont icon-chakan"></el-button>
                </el-tooltip> -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    v-auth="'/deviceaccess/index:updateDevice'"
                    @click="update(scope.row)"
                    icon="iconfont icon-xiugai"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('deviceAccess.button.delete')"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    @click="delDevBtn(scope.row)"
                    v-auth="'/deviceaccess/index:deleteDevice'"
                    icon="iconfont icon-shanchu"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改类型名称 -->
    <el-dialog
      title="设置控制器编号名称"
      :visible.sync="dialogControlCode"
      width="500px"
      :before-close="
        () => {
          dialogControlCode = false;
        }
      "
    >
      <el-form
        ref="formControlCode"
        :rules="rules"
        :model="formControlCode"
        label-width="120px"
      >
        <el-form-item label="控制器原名称：">
          <span>{{ formControlCode.controlCodeTypeName }}</span>
        </el-form-item>
        <el-form-item label="控制器新名称：" prop="name">
          <el-input v-model="formControlCode.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogControlCode = false">取 消</el-button>
        <el-button @click="onSaveControlCode" type="primary">确 认</el-button>
      </span>
    </el-dialog>
    <!-- 修改弹窗 -->
    <el-dialog
      title="修改区域"
      v-ops:width="500"
      v-dialogDrag
      :visible.sync="formShow"
      @close="formClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form">
        <el-form-item label="区域名称：" label-width="100px" prop="name">
          <el-input v-model="areaName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述：" label-width="100px" prop="name">
          <el-input v-model="description" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveArea" v-status> 保存 </el-button>
        <el-button @click="formClose"> 取消 </el-button>
      </span>
    </el-dialog>
    <!-- 设置密码 -->
    <el-dialog title="设置密码" :visible.sync="dialogVisible" v-dialogDrag width="580px">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧密码" prop="oldUnlockPassword">
          <el-input
            type="password"
            v-model="ruleForm.oldUnlockPassword"
            autocomplete="off"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newUnlockPassword">
          <el-input
            type="password"
            v-model="ruleForm.newUnlockPassword"
            autocomplete="off"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmUnlockPassword">
          <el-input
            type="password"
            v-model="ruleForm.confirmUnlockPassword"
            autocomplete="off"
            placeholder="请输入确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reset('ruleForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ElementTreeLine from "element-tree-line";
import { api } from "../../api/index";
import { Dic, Dates } from "$utils";
import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../../config/fireTable";
import { partOption } from "../../config/partTable";
import sha256 from "js-sha256";

export default {
  components: {
    ElementTreeLine,
  },
  filters: {
    // 子设备类型过滤
    deviceSubType: function (val) {
      switch (val) {
        case "2":
          return i18n.t("deviceAccess.label.cameradev");
        case "3":
          return i18n.t("deviceAccess.label.langdev");
        case "4":
          return i18n.t("deviceAccess.label.alarmdev");
      }
    },
  },
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        if (this.ruleForm.newUnlockPassword !== "") {
          this.$refs.ruleForm.validateField("newUnlockPassword");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      let reg = new RegExp(
        "^(((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^\\s0-9a-zA-Z])|(?=.*[a-zA-Z])(?=.*[^\\s0-9a-zA-Z]))[^\\s]+)$"
      );
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("base.message.passwordCheck2")));
      } else {
        if (this.ruleForm.confirmUnlockPassword !== "") {
          this.$refs.ruleForm.validateField("confirmUnlockPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newUnlockPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      downFileName: "importFireTemplate",
      pageState: "add",
      controlCodeData: Dic.find("SENU095001"),
      controlCodeValue: [],
      dialogControlCode: false,
      formControlCode: {
        name: "",
      },
      controlCodeOption: [],
      activeName: "first",
      tipData: "",
      // 单个删除设备的数据
      delDevSin: {},
      delConfirm: false,
      // 设备详情数据
      devDtail: {
        deviceHost: "",
        thirdDeviceId: "",
        parentCode: "",
        type: "",
        netType: "",
        enableVoice: "",
        deviceCreateTime: "",
        deviceSubType: "",
        isExDomain: "",
        deviceName: "",
        domainCode: "",
        cameraLocation: "",
        status: "",
        isSupportIntelligent: "",
        nvrCode: "",
      },
      // 详情弹框
      dialogVisible: false,
      // 存储列表数据获取方式：1、通过左侧树；2、通过搜索条件；删除时用同样的方式刷新列表数据
      getDevListType: "",
      // 选中设备ID集合
      selDev: [],
      // 查询字段
      queryForm: {
        // mac: "",
        deviceName: "",
        thirdDeviceId: "",
        deviceMarkList: ["27", "28", "29", "35", "36", "37"],
      },
      cameraQueryForm: {
        parentDeviceId: "",
        mac: "",
        deviceName: "",
      },
      // 系统id
      systemId: 200000024,
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      cameraPage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceData: [],
      cameraData: [],
      videoStreamData: [],
      deviceOption: tableOption(this),
      cameraOption: partOption(this),
      level: "",
      devShow: true,
      cameraCount: {
        deviceAllCount: null,
        deviceOnlineCount: null,
        deviceOfflineCount: null,
      },
      statusOptions: [
        {
          label: "在线",
          value: "1",
        },
        {
          label: "离线",
          value: "0",
        },
      ],
      areaName: "",
      description: "",
      areaCode: "",
      formShow: false,
      statusFormShow: false,
      ruleForm: {
        oldUnlockPassword: "",
        newUnlockPassword: "",
        confirmUnlockPassword: "",
      },
      rules: {
        oldUnlockPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { validator: validateOldPass, trigger: "blur" },
        ],
        newUnlockPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        confirmUnlockPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入控制器名称", trigger: "blur" }],
      },
      // 判断是新增还是修改窗口
      isAddControlCode: true,
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.platID = this.$route.query.platID;
    this.factoryId = this.$route.query.factoryId;
    this.deviceType = this.$route.query.deviceType;
  },
  mounted() {
    // 请求树根节点
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.getDevList();
    this.queryFactoryList();
  },
  methods: {
    //模板下载
    downTemplate () {
      this.$fetchGet(api.fire.getTemplateFile, {
        responseType: "blob", //设置返回类型
      }).then((res) => {
        if (typeof window.chrome !== "undefined") {
          // Chrome version
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const url = window.URL || window.webkitURL || window.moxURL;
          const urls = url.createObjectURL(blob);
          const a = document.createElement("a"); // 生成虚拟a标签
          a.href = urls;
          a.download = this.downFileName + ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          url.revokeObjectURL(urls); // 释放掉blob对象
        } else if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE version
          const blob = new Blob([res], { type: "application/force-download" });
          window.navigator.msSaveBlob(blob, this.downFileName + ".xlsx");
        } else {
          // Firefox version
          const file = new File([res], this.downFileName + ".xlsx", {
            type: "application/force-download",
          });
          window.open(URL.createObjectURL(file));
        }
      });
    },
    // 批量导入按钮
    batchImport (file) {
      if (
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xlsx" &&
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        formData.set("deviceId",this.parentDeviceId);
        // 调用导入接口
        this.$fetch(api.fire.importFireDevice, formData).then((response) => {
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.requestCameraList();
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    onControlChooseCode(val) {
      this.$refs.devTab.setForm("controlCodeList", val);
    },
    onSaveControlCode() {
      this.$refs.formControlCode.validate((valid) => {
        if (valid) {
          // 新增情况下不需要调接口，本地存储即可
          if (this.pageState == "edit") {
            this.$fetch(api.device.updateFireFightingControlCodeType, {
              controlCodeTypeCode: this.formControlCode.controlCodeTypeCode,
              controlCodeTypeName: this.formControlCode.name,
              deviceId: this.rowInfo.deviceID,
            }).then((response) => {
              if (!response.success) {
                this.$message.error(response.msgContent);
              } else {
                this.dialogControlCode = false;
                this.getControlCodeOption(this.rowInfo);
              }
            });
          } else {
            this.controlCodeData.forEach((el) => {
              if (el.value == this.formControlCode.controlCodeTypeCode) {
                el.label = this.formControlCode.name;
              }
            });
            this.dialogControlCode = false;
          }
        }
      });
    },
    onEditControlCodeType(item) {
      this.dialogControlCode = true;
      this.formControlCode.controlCodeTypeName = item.controlCodeTypeName || item.label;
      this.formControlCode.controlCodeTypeCode = item.controlCodeTypeCode || item.value;
      this.formControlCode.name = "";
    },
    getControlCodeOption(row) {
      this.$fetch(api.device.getFireFightingControlCodeTypeList, {
        deviceId: row.deviceID,
      }).then((res) => {
        if (res.success) {
          this.controlCodeOption = res.returnObj || [];
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 返回按钮
    retBtn() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/deviceaccess/index",
      });
    },

    // 树的子节点点击事件
    currentChange(data, node) {
      console.log("树的子节点点击", data);
      this.isTopTreeNode = data.areaCode !== "-1" ? false : true;
      // let parentNode = this.$refs.vuetree.getNode(data.parentCode)
      this.areaCode = data.areaCode;
      this.queryForm.thirdDeviceId = data.thirdDeviceId;
      this.treeKey = data.deviceID;
      this.level = node.level;
      if (this.level) {
        this.deviceId = data.deviceID;
      }
      this.getDevList();
    },
    getAccessDeviceInfoTree() {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.frame = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.vuetree.setCurrentKey(this.frame[0]);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 请求数据列表数据
    requestList() {
      const param = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
        systemId: this.systemId,
        // mac: this.queryForm.mac,
        thirdDeviceId: this.queryForm.thirdDeviceId,
        deviceName: this.queryForm.deviceName,
        deviceMarkList: ["27", "28", "29", "35", "36", "37"], // 固定值
      };
      this.$fetch(api.device.queryFireDevice, param).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 请求数据列表数据
    requestCameraList() {
      const params = {
        pageSize: this.cameraPage.pageSize,
        pageNum: this.cameraPage.currentPage,
        systemId: this.systemId,
        parentDeviceId: this.parentDeviceId,
        mac: this.cameraQueryForm.mac,
        deviceName: this.cameraQueryForm.deviceName,
      };
      this.$fetch(api.device.queryFireSubDevice, params).then((res) => {
        if (res.success && res.returnObj.list) {
          this.cameraData = res.returnObj.list;
          this.cameraPage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 根据查询条件查询列表
    queryDev() {
      if (this.devShow) {
        this.devicePage.currentPage = 1;
        this.getDevListType = 1;
        this.requestList();
      } else {
        this.requestCameraList();
      }
    },
    // 根据树查询设备列表
    getDevList() {
      this.devicePage.currentPage = 1;
      this.getDevListType = 2;
      this.requestList();
    },

    // 批量删除设备
    delDev() {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.deletePlatDevice();
      });
    },
    // 单独删除设备
    delDevBtn(row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        if (this.devShow) {
          this.deletePlatDevice(row);
        } else {
          this.deleteSubDevice(row);
        }
      });
    },
    // 确认删除
    deletePlatDevice(row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      this.$fetch(api.device.deleteFireDevice, params).then((res) => {
        if (res.success) {
          if (this.getDevListType == 1) {
            this.queryDev();
          } else if (this.getDevListType == 2) {
            this.getDevList();
          }
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.devTab.selectClear();
      });
    },
    // 确认删除
    deleteSubDevice(row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      this.$fetch(api.device.deletePlatSystemDevice, params).then((res) => {
        if (res.success) {
          this.requestCameraList();
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.partTab.selectClear();
      });
    },

    // 取消删除
    dlgNo() {
      this.delConfirm = false;
    },

    refresh(row) {
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then((res) => {
        if (res.success) {
          row.status = res.returnObj.status;
          this.$message.success(res.msgContent);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    //迭代四  新接口 查看详情
    showDetail(row) {
      if (this.devShow) {
        // if (
        //   row.controlMode === "1" &&
        //   (row.deviceMark == 28 || row.deviceMark == 29)
        // ) {
        //   this.deviceOption.column[14].viewDisplay = true;
        // } else {
        //   this.deviceOption.column[14].viewDisplay = false;
        // }
        this.$refs.devTab.rowView(row);
      } else {
        this.$refs.partTab.rowView(row);
      }
    },
    //查看部件列表
    seeCamera(row) {
      this.parentDeviceId = row.deviceID;
      this.parentThirdDeviceId = row.thirdDeviceId;
      this.factoryId = row.factoryId;
      this.devShow = false;
      this.requestCameraList();
    },
    seeStatus(row) {
      console.log("row", row);
      const params = {
        pageNum: 1,
        pageSize: 10,
        thirdDeviceId: row.thirdDeviceId,
      };
      this.$fetch(api.device.queryVideoStream, params).then((res) => {
        if (res.success) {
          this.videoStreamData = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    backNvr() {
      this.devShow = true;
      this.cameraQueryForm = {
        parentDeviceId: "",
        mac: "",
        deviceName: "",
      };
    },
    // 重置搜索
    resetForm() {
      if (this.devShow) {
        this.devicePage.pageSize = utils.Cache.get("CURRENT_PAGESIZE") || 10;
        this.devicePage.pageNo = 1;
        this.queryForm = {
          mac: "",
          deviceName: "",
          thirdDeviceId: "",
          deviceMarkList: ["27", "28", "29", "35", "36", "37"], // 固定值
        };
        this.getAccessDeviceInfoTree();
        // 请求设备列表

        this.getDevListType = 2;
        this.treeKey = "";
        this.requestList();
        this.devicePage.currentPage = 1;
      } else {
        this.cameraQueryForm = {
          parentDeviceId: "",
          mac: "",
          deviceName: "",
        };
        this.requestCameraList();
      }
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      if (this.devShow) {
        this.devicePage.currentPage = val;
        if (this.getDevListType == 1) {
          this.getDevListType = 1;
          this.requestList();
        } else if (this.getDevListType == 2) {
          this.getDevListType = 2;
          this.requestList();
        }
      } else {
        this.cameraPage.currentPage = val;
        this.requestCameraList();
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      if (this.devShow) {
        this.devicePage.currentPage = 1;
        this.devicePage.pageSize = val;
        if (this.getDevListType == 1) {
          this.queryDev();
        } else if (this.getDevListType == 2) {
          this.getDevList();
        }
      } else {
        this.cameraPage.currentPage = 1;
        this.cameraPage.pageSize = val;
        this.requestCameraList();
      }
    },
    isShowControlCodeColumn(data) {
      console.log(data);
      if (this.pageState == "edit") {
        this.getControlCodeOption(data);
      }
      // 当是排烟防烟系统和灭火系统 且是多分机模式下可选择控制器编号
      if (this.isAddControlCode) {
        // 新增
        if (data.deviceMark == 36 || data.deviceMark == 37) {
          this.deviceOption.column[11].addDisplay = true;
          this.deviceOption.column[12].addDisplay = true;
          this.deviceOption.column[13].addDisplay = true;
          this.deviceOption.column[14].addDisplay = true;
          this.deviceOption.column[15].addDisplay = true;
        } else {
          this.deviceOption.column[11].addDisplay = false;
          this.deviceOption.column[12].addDisplay = false;
          this.deviceOption.column[13].addDisplay = false;
          this.deviceOption.column[14].addDisplay = false;
          this.deviceOption.column[15].addDisplay = false;
        }

        // if (
        //   data.controlMode === "1" &&
        //   (data.deviceMark == 28 || data.deviceMark == 29)
        // ) {
        //   this.deviceOption.column[9].addDisplay = true;
        // } else {
        //   this.deviceOption.column[9].addDisplay = false;
        // }
      } else {
        // 编辑
        if (data.deviceMark == 36 || data.deviceMark == 37) {
          this.deviceOption.column[11].editDisplay = true;
          this.deviceOption.column[12].editDisplay = true;
          this.deviceOption.column[13].editDisplay = true;
          this.deviceOption.column[14].editDisplay = true;
          this.deviceOption.column[15].editDisplay = true;
        } else {
          this.deviceOption.column[11].editDisplay = false;
          this.deviceOption.column[12].editDisplay = false;
          this.deviceOption.column[13].editDisplay = false;
          this.deviceOption.column[14].editDisplay = false;
          this.deviceOption.column[15].editDisplay = false;
        }
        // if (
        //   data.controlMode === "1" &&
        //   (data.deviceMark == 28 || data.deviceMark == 29)
        // ) {
        //   this.deviceOption.column[9].editDisplay = true;
        // } else {
        //   this.deviceOption.column[9].editDisplay = false;
        // }
      }
    },
    addClick(event) {
      event.stopPropagation();
    },
    editArea(node, data) {
      this.areaName = data.areaName;
      this.areaCode = data.areaCode;
      this.description = data.description;
      this.formShow = true;
    },
    formClose() {
      this.formShow = false;
      this.areaName = "";
    },
    saveArea() {
      const params = {
        areaCode: this.areaCode,
        areaName: this.areaName,
        description: this.description,
        connectMode: "EDGE",
        pushDomain: "push.sdnewtimes.com",
        pullDomain: "play.sdnewtimes.com",
      };
      this.$fetch(api.device.updateArea, params).then((res) => {
        if (res.success) {
          this.formShow = false;
          this.getAccessDeviceInfoTree();
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    add() {
      this.pageState = "add";
      this.controlCodeData = Dic.find("SENU095001");
      // console.log('this.devShow', this.devShow);
      if (this.devShow) {
        this.isAddControlCode = true;
        this.$refs.devTab.rowAdd();
      } else {
        this.$refs.partTab.rowAdd();
      }
    },
    update(row) {
      this.pageState = "edit";
      // this.getControlCodeOption(row)
      this.rowInfo = { ...row };
      if (this.devShow) {
        // 主机
        this.isAddControlCode = false;
        this.isShowControlCodeColumn(this.rowInfo);
        row.deviceVersion = Number(row.deviceVersion);
        row.deviceMark = Number(row.deviceMark);
        row.controlCodeList = [];
        if (row.controlCode) {
          let arr = row.controlCode.split(",");
          arr.forEach((item) => {
            row.controlCodeList.push(Number(item));
          });
        }
        this.$refs.devTab.rowEdit(row);
      } else {
        // 部件
        row.subDeviceMark = Number(row.subDeviceMark);
        this.$refs.partTab.rowEdit(row);
      }
    },
    // 新增主机
    handleCreate(addInfo, done) {
      let form = {
        parentDeviceId: this.systemId,
        parentDeviceIds: this.systemId,
        systemId: this.systemId,
        // waterLevel: addInfo.waterLevel,
        // controlCodeList: addInfo.controlCodeList,
        // controlMode: addInfo.controlMode,
        // factoryId: addInfo.factoryId,
        ctrlThirdDeviceId: addInfo.ctrlThirdDeviceId,
        thirdDeviceName: addInfo.deviceName,
        allControlCodeList: this.controlCodeData.map((el) => {
          return {
            controlCodeTypeCode: el.value,
            controlCodeTypeName: el.label,
          };
        }),
      };
      const params = Object.assign(addInfo, form);
      console.log(params);
      this.$fetch(api.device.addFireDevice, params).then((res) => {
        if (res && res.success) {
          done();
          this.requestList();
          this.$message.success("新增成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handlePartCreate(addInfo, done) {
      let form = {
        factoryId: this.factoryId,
        thirdDeviceId: this.parentThirdDeviceId,
      };
      const params = Object.assign(addInfo, form);
      this.$fetch(api.device.addFireSubDevice, params).then((res) => {
        if (res && res.success) {
          done();
          this.requestCameraList();
          this.$message.success("新增成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handlePartUpdate(updateInfo, done) {
      let form = {
        deviceID: this.rowInfo.deviceID,
        factoryId: this.factoryId,
        subDeviceMark: updateInfo.subDeviceMark,
        mac: updateInfo.mac,
        loop: updateInfo.loop,
        thirdDeviceName: updateInfo.thirdDeviceName,
        thirdDeviceDesc: updateInfo.thirdDeviceDesc,
        secondaryCode: updateInfo.secondaryCode,
        controlCode: updateInfo.controlCode,
      };
      this.$fetch(api.device.updateFireSubDevice, form).then((res) => {
        if (res && res.success) {
          done();
          this.requestCameraList();
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 修改主机
    handleUpdate(updateInfo, done) {
      let form = {
        waterLevel: updateInfo.waterLevel,
        lowWaterThreshold: updateInfo.lowWaterThreshold,
        llowWaterThreshold: updateInfo.llowWaterThreshold,
        highWaterThreshold: updateInfo.highWaterThreshold,
        hhighWaterThreshold: updateInfo.hhighWaterThreshold,
        deviceMark: this.rowInfo.deviceMark,
        controlMode: updateInfo.controlMode,
        // codeType: updateInfo.codeType,
        deviceID: this.rowInfo.deviceID,
        factoryId: updateInfo.factoryId,
        // deviceHost: updateInfo.deviceHost,
        // mac: updateInfo.mac,
        status: updateInfo.status,
        ctrlThirdDeviceId: updateInfo.ctrlThirdDeviceId,
        // typeMark: updateInfo.typeMark,
        thirdDeviceName: updateInfo.deviceName,
        thirdDeviceDesc: updateInfo.thirdDeviceDesc,
        deviceVersion: updateInfo.deviceVersion,




      };
      // if (
      //   updateInfo.controlMode == "1" &&
      //   (this.rowInfo.deviceMark == 28 || this.rowInfo.deviceMark == 29)
      // ) {
      //   form.controlCodeList = updateInfo.controlCodeList;
      // }
      this.$fetch(api.device.updateFireDevice, form).then((res) => {
        if (res && res.success) {
          done();
          this.requestList();
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    queryFactoryList() {
      this.$fetch(api.device.queryFireDeviceFactoryList).then((res) => {
        if (res.success) {
          this.deviceOption.column[3].dicData = res.returnObj.map((item) => {
            return {
              label: item.factoryName,
              value: Number(item.factoryId),
            };
          });
        }
      });
    },
    exportData() {
      const params = {
        systemId: this.systemId, // 固定值
        // mac: this.queryForm.mac, // 系统地址
        deviceName: this.queryForm.deviceName, // 设备名称
        thirdDeviceId: this.queryForm.thirdDeviceId, // 唯一标识号
        deviceMarkList: ["27", "28", "29", "35", "36", "37"], // 固定值
      };
      this.$fetchDownLoad(api.device.exportFireDevice, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          //  console.log('date',window.DATE)
          const fileName =
            "消防主机列表" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    handleSearchChange(param) {
      console.log("param", param);
      if (this.devShow) {
        this.queryForm = param;
        this.devicePage.currentPage = 1;
        this.requestList();
      } else {
        this.cameraQueryForm.deviceName = param.thirdDeviceName;
        this.cameraQueryForm.mac = param.mac;
        this.cameraPage.currentPage = 1;
        this.requestCameraList();
      }
    },
    setPassword(row) {
      this.dialogVisible = true;
      this.deviceId = row.deviceID;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            deviceId: this.deviceId,
            oldUnlockPassword: sha256(this.ruleForm.oldUnlockPassword),
            newUnlockPassword: sha256(this.ruleForm.newUnlockPassword),
            confirmUnlockPassword: sha256(this.ruleForm.confirmUnlockPassword),
          };
          this.$fetch(api.device.updateDeviceUnlockPassword, params).then((res) => {
            if (res.success) {
              this.$message.success("修改成功");
              this.$refs[formName].resetFields();
              this.dialogVisible = false;
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.rightBtn {
  display: none;
  @include set_theme_color(color, main-theme-color);
}
.el-select-dropdown__item {
  &:hover {
    .rightBtn {
      float: right;
      font-size: 13px;
      display: block !important;
    }
  }
}
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
  .upload-demo {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .nvr-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        .tree-label {
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
  .scroll-bar-view {
    margin: 15px 0;
    // @include set_theme_color(background-color, top-menu-bg-color);
    height: calc(100% - 50px);
    .el-scrollbar__wrap {
      // height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
